

















import { Component, Vue } from "vue-property-decorator";
import FreightTemplate from "./components/FreightTemplate.vue";
import Table from "./components/Table.vue";
import print from "../../utils/print";
import Dialog from "./components/Dialog.vue";
import copy from "@/utils/deepCopy";

@Component({
  components: {
    FreightTemplate,
    Table,
    Dialog,
  },
})
export default class Freight extends Vue {
  provinces: any = JSON.parse(localStorage.getItem("ybc_provinces") || ""); // 省份列表
  form: any = {}; // 表单(编辑模板的时候用来传值)
  dialogVisibleEdit: boolean = false; // 编辑对话框

  // 获取省份信息
  getProvinces(val: any) {
    this.provinces = val;
  }
  // 更新数据
  updateTable() {
    let table: any = this.$refs.table;
    table.getData();
  }
  // 编辑
  handleEdit(val: any) {
    this.form = copy(val);
    this.dialogVisibleEdit = true;
  }
  // 关闭对话框
  closeDialog() {
    this.dialogVisibleEdit = false;
  }
}
